export default {
    state: {
        loading: false,
        /*
        * status = 0 -> No loading has begun
        * status = 1 -> Loading has started
        * status = 2 -> Loading completed successfully
        * status = 3 -> Loading completed unsuccessfully
        * */
        users: [],
    },
    mutations: {
        setUsers(context, state) {
            context.users = state;
        }
    },
    getters: {
        getUsers(context) {
            return context.users;
        }
    },
}
